import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ClusterJobs } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
export const SYSTEM_JOBS_KEY = "systemJobs";
const refetchInterval = 3e3;
const useSystemJobsQuery = () => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: [SYSTEM_JOBS_KEY],
    queryFn: () => defaultOnError(ClusterJobs.list(), "Loading system jobs failed with status"),
    retry: 0,
    refetchInterval,
    placeholderData: keepPreviousData,
    notifyOnChangeProps: ["data", "error"],
    initialData: {}
  });
  return { data, isLoading, isFetching };
};
export default useSystemJobsQuery;
